import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs/index';
import { LoginService } from './login/login.service';

@Injectable()
export class AuthGuardService implements CanActivate {
  constructor(private loginService: LoginService, private router: Router) {}

    canActivate(route: ActivatedRouteSnapshot,state: RouterStateSnapshot): boolean {
		const url: string = state.url;
		const userData = JSON.parse(localStorage.getItem('user'));
		return this.checkLogin(url);
    }
	checkLogin(url: string): boolean {
    if (this.loginService.isLoggedIn(url)) {
      return true;
    }else {
		this.router.navigate(['/']);
	}

    /* const dashboardPrefix = environment.dashboardPrefix === '/' ? '' : environment.dashboardPrefix;

    if (url === dashboardPrefix + '/login') {
      const userData = JSON.parse(localStorage.getItem('user'));
      if (userData) {
        const redirectUrl = this.beforePreviousUrl ? this.beforePreviousUrl : userData.roles.menu_tab[0].path;
        this.router.navigate([dashboardPrefix + redirectUrl]);
      } else {
        return true;
      }
    } else {
      // Store the attempted URL for redirecting
      this.loginService.redirectUrl = url;

      // Navigate to the login page with extras
      this.router.navigate([dashboardPrefix + '/login']);
    }

    return false; */
  }
}